<template>
  <iframe
    class="mondays-view-frame"
    src="https://view.monday.com/embed/1888763354-1119778352da44654ba18e75ae43f015?r=use1"
  ></iframe>
</template>

<script>
  export default {
    name: 'FinishedWork',
  };
</script>

<style scoped>
.mondays-view-frame {
  border: 0;
  box-shadow: 5px 5px 56px 0 rgba(0, 0, 0, 0.25);
  width: 100%;
  height: calc(100vh - 94px);
}
</style>
